import { CATALOG_REGISTRATION_FORM_STORAGE_KEY } from '../vars'
import { useSessionStorage } from '../../../../youtalk-storybook/src/ui'

export const useCatalogRegistrationFormStorage = (initialState) =>
  useSessionStorage(CATALOG_REGISTRATION_FORM_STORAGE_KEY, initialState)
